export default "__VITE_ASSET__DYrehBdT__"